export interface LayerCrossFilter {
  field: string;
  value: unknown;
  layerId?: string;
}

export function filterFeaturesByCrossFilters(
  features: GeoJSON.Feature[],
  crossFilters: Iterable<LayerCrossFilter>,
  layerId: string,
): GeoJSON.Feature[] {
  const filters = Array.from(crossFilters);
  if (filters.length === 0) return features;
  return features.filter((feature) => {
    for (const filter of filters) {
      if (filter.layerId && filter.layerId !== layerId) continue;
      const propertyValue = feature.properties?.[filter.field];
      if (propertyValue == null) return false;
      if (Array.isArray(filter.value)) {
        if (!filter.value.some((value) => String(value).toLowerCase() === String(propertyValue).toLowerCase())) {
          return false;
        }
      } else if (String(propertyValue).toLowerCase() !== String(filter.value).toLowerCase()) {
        return false;
      }
    }
    return true;
  });
}
